// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9ab5fed8","239":"8bbacedb","455":"038c9878"}[chunkId] + ".chunk.js";
};